import React, { useState } from 'react'
import { Button, Modal, Progress, Popconfirm } from "antd"
import { updateInfoBox, validateFBAFullyBoxed } from '../../../services/api/apiNextBox'
import { ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons'

function FinishUpdateInfoModal(props) {
    const { visible, onCancel, selectedItems, setSelectedItems, reload } = props
    const [loading, setLoading] = useState(false)
    const [listSuccess, setListSuccess] = useState([])
    const [listError, setListError] = useState([])
    const [processed, setProcessed] = useState([])

    // Chỉ xử lý/hiển thị các thùng CHƯA kết thúc cập nhật. Thùng đã kết thúc rồi không đưa lên modal.
    const boxesToFinish = (selectedItems || []).filter(box => box.is_finish_update_fba_info !== true)

    // Danh sách hiển thị: sau khi xử lý thì dùng kết quả (có flag), trước đó dùng danh sách cần xử lý.
    const displayList = processed.length > 0 ? processed : boxesToFinish

    // Tái sử dụng logic của _handleClickSave (ModalEditInfoBox.js): chỉ "khóa" thông tin,
    // giữ nguyên cân nặng/kích thước hiện có của thùng, không cho nhập lại.
    const _onFinishUpdateInfoBox = async (box) => {
        try {
            let warning = ''
            // Thùng FBA chưa đóng đủ hàng → vẫn cho kết thúc cập nhật nhưng cảnh báo cho user
            if (box.is_fba_box === true) {
                const res = await validateFBAFullyBoxed(box.id)
                if (res.data.data === false) {
                    warning = 'Thùng chưa được đóng hết'
                }
            }

            const data = {
                confirm_update_fba_info: true,
                weight: box.real_weight,
                dimension: {
                    width: box.real_width,
                    height: box.real_height,
                    length: box.real_length,
                }
            }

            const { data: response } = await updateInfoBox({ boxId: box.id, data })
            const { success, message } = response

            if (!success) {
                return { success: false, message: message }
            }

            return { success: true, warning }
        } catch (e) {
            return { success: false, message: e.message }
        }
    }

    const _onSubmitChange = async () => {
        setLoading(true)
        setListSuccess([])
        setListError([])
        setProcessed([])

        let result = []

        await Promise.all(boxesToFinish.map(async item => {
            const response = await _onFinishUpdateInfoBox(item)

            const { success, message, warning } = response

            if (!success) return result.push({ ...item, error: message, processing: false })

            return result.push({ ...item, success: true, warning: warning || '', processing: false })
        }))

        let newListSuccess = []
        let newListError = []

        result.forEach(process => {
            if (process.success === true) {
                newListSuccess.push(process)
            } else if (process.error && process.error.length > 0) {
                newListError.push(process)
            }
        })

        reload()
        setListSuccess(newListSuccess)
        setListError(newListError)
        setLoading(false)
        setProcessed(result)
    }

    const handleCloseModal = () => {
        onCancel('FinishUpdateInfoModal')
        setListSuccess([])
        setListError([])
        setProcessed([])
        // Reset (bỏ tick) các thùng đã chọn khi đóng modal
        setSelectedItems([])
    }

    const warningCount = displayList.filter(item => item.success && item.warning).length
    const disableSave = loading || boxesToFinish.length === 0 || (!!listSuccess.length || !!listError.length)

    return (
        <Modal
            className="FinishUpdateInfoModal AddSizeWeightModal"
            visible={visible}
            title="Kết thúc cập nhật thông tin"
            onCancel={handleCloseModal}
            width='780px'
            footer={[
                <Button key="back" disabled={loading} className='mr-2' onClick={handleCloseModal}>
                    Cancel
                </Button>,
                <Popconfirm
                    key="submit"
                    title={`Kết thúc cập nhật thông tin ${boxesToFinish.length} thùng?`}
                    onConfirm={_onSubmitChange}
                    okText="Yes"
                    cancelText="No"
                    disabled={disableSave}
                >
                    <Button disabled={disableSave} type="primary" loading={loading}>
                        Kết thúc cập nhật
                    </Button>
                </Popconfirm>
            ]}
        >
            <h3>List processing <span>{boxesToFinish.length}</span> items</h3>
            {
                (listSuccess.length > 0 || listError.length > 0) &&
                <div className="Results">
                    <div className="ResultSuccess">
                        Success: <span>{listSuccess.length}</span> items
                    </div>
                    {
                        warningCount > 0 &&
                        <div className="ResultWarning">
                            Cảnh báo: <span>{warningCount}</span> items
                        </div>
                    }
                    <div className="ResultError">
                        Error: <span>{listError.length}</span> items
                    </div>
                </div>
            }

            <div className="ListProcessing">
                <ul>
                    {
                        displayList.length > 0 && displayList.map(item => (
                            <li key={item._id}>
                                <span className='font-weight-bold'>#{item.id}</span>
                                {
                                    !!item.error &&
                                    <span className="Error"><ExclamationCircleOutlined /> {item.error}</span>
                                }
                                {
                                    item.success && !!item.warning &&
                                    <span className="Warning"><ExclamationCircleOutlined /> Đã kết thúc cập nhật — {item.warning}</span>
                                }
                                {
                                    item.success && !item.warning &&
                                    <span className="Success"><CheckCircleOutlined /> Kết thúc cập nhật thành công</span>
                                }
                                <Progress
                                    percent={(!!item.success || !!item.error) ? 100 : 0}
                                    size="small"
                                    status={`${(item.processing === false && item.success === true) ? 'success' : ((item.processing === false && item.error && item.error.length > 0) ? 'exception' : 'active')}`}
                                    showInfo={false}
                                />
                            </li>
                        )
                        )
                    }
                </ul>
            </div>
        </Modal>
    )
}

export default FinishUpdateInfoModal
